<template>
  <div
    class="lyric height-all"
    :class="{
      'lyric-edit-mode': renderData.editMode,
      'lyric-edit-mode-active': renderData.lyric.length,
      [`lyric-${createRenderType}`]: true,
      'lyric-edit-mode-disabled': !(
        userDataStore.isLogin ||
        curDriverKey != 'click_to_ai_generate_more_row--false'
      ),
      'lyric-edit-mode-tour-show':
        createEditGuidTourVisible && createEditGuidTourControlVisible,
      'lyric-edit-mode-loading':
        renderData.isLoading &&
        renderData.curGenerateType == 'lyric_optimize' &&
        globalConfig.appname == chinaAppName,
    }"
    @click.stop="onClickOutside"
  >
    <div
      class="lyric-box flex"
      :class="{
        'lyric-box-disabled':
          !(
            userDataStore.isLogin ||
            curDriverKey != 'click_to_ai_generate_more_row--false'
          ) && $$language() != 'cn',
      }"
    >
      <div class="lyric-title flex" @click="handleEditBoxClick">
        <div class="lyric-title-input-box flex1 height-0">
          <textarea
            ref="refTitleInput"
            class="input-text fn-inline"
            :value="renderData.title"
            @input="onInputTitle"
            @blur="onBlurTitle"
            @focus="onFocusTitle"
            :readonly="renderData.isLoading"
            :placeholder="$$t('create.enter_song_title_placeholder')"
            @compositionstart="handleCompositionStart"
            @compositionend="handleCompositionEnd"
          />
        </div>
        <div class="lyric-title-btn flex">
          <div class="lyric-title-btn-box" @click.stop>
            <Button
              loadingColorClass="white"
              @click="onWriteSingleLyricClick"
              :loading="
                renderData.curGenerateType == 'randomLyrics' &&
                renderData.isLoading
              "
              :disabled="renderData.isLoading"
              :renderStyle="{
                '--padding': '0 12px',
                '--width': 'max-content',
                '--height': '32px',
                '--borderRadius': '50px',
                '--background': 'rgba(148, 173, 255, 1)',
                '--fontColor': '#000',
                '--fontSize': '14px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(148, 173, 255, 0.75)',
                '--fontColorHover': '#000',
              }"
            >
              <i class="block ico-random" v-if="!isEffectiveTitle"></i>
              <span class="width-100 olh"
                >{{
                  isEffectiveTitle
                    ? $$tValue("create.lyrics_about", {
                        song_title: renderData.title,
                      })
                    : $$t("create.ai_generate_random_lyrics")
                }}
              </span>
            </Button>
          </div>
        </div>
        <!-- <i class="fn-inline"></i> -->
      </div>
      <div class="lyric-edit flex1">
        <LyricEdit
          ref="refLyricEdit"
          :lyric="renderData.lyric"
          :isLoading="renderData.isLoading"
          @countChange="onCountChange"
          @input="onInput"
          @change="onChange"
          @blur="onBlur"
          @focus="onFocus"
          @cursorPositionChange="onCursorPositionChange"
        ></LyricEdit>
      </div>
      <div class="lyric-footer-count-box">
        <div
          class="lyric-footer-count"
          :class="{ 'count-error': renderData.charCount >= MAX_LYRIC_COUNT }"
        >
          {{ renderData.charCount }}/{{ MAX_LYRIC_COUNT }}
        </div>
        <div class="lyric-footer flex">
          <div class="lyric-footer-btn btn1">
            <Bubble
              placement="top"
              :disabled="renderData.tagVisible || renderData.isLoading"
            >
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100%',
                  '--height': '100%',
                  '--borderRadius': '8px 0px 0px 8px',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--fontColor': '#fff',
                  '--fontSize': '11px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                  '--fontColorHover': '#fff',
                }"
                :disabled="
                  renderData.isLoading ||
                  renderData.charCount > MAX_LYRIC_COUNT - 10
                "
                @click.stop="toggleTagVisible"
              >
                <div class="lyric-footer-btn-content">
                  <i class="block"></i>
                  <span class="block olh">{{
                    $$t("create.song_structure_btn")
                  }}</span>
                </div>
              </Button>
              <template v-slot:content>
                <div class="lyric-footer-btn-tip-content">
                  <template
                    v-for="(item, index) in $$tm(
                      'editor.song_structure_tip'
                    ).split('\n')"
                    :key="index"
                  >
                    <p>
                      {{ item }}
                    </p>
                  </template>
                </div>
              </template>
            </Bubble>
            <div class="lyric-tag-items" v-if="renderData.tagVisible">
              <template v-for="(item, index) in getSegTypes()" :key="index">
                <div
                  class="lyric-tag-item tc pointer"
                  @click.stop="
                    () => {
                      doAddTag(item);
                    }
                  "
                >
                  {{ item[`label_${$$language()}`] }}
                </div>
              </template>
            </div>
          </div>

          <div
            class="lyric-footer-btn btn3"
            :class="{
              'driver-high-optimize-active':
                renderData.lyricOptimizeGuidVisibleCount == 1,
            }"
          >
            <Bubble
              :openDelay="3"
              effect="dark"
              :disabled="
                renderData.lyricOptimizeGuidVisibleCount == 1 ||
                renderData.isLoading ||
                curDriverKey == 'click_to_ai_generate_more_row--false'
              "
              placement="top"
            >
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100%',
                  '--height': '100%',
                  '--borderRadius': '0',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--fontColor': '#fff',
                  '--fontSize': '11px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                  '--fontColorHover': '#fff',
                }"
                :disabled="
                  renderData.isLoading ||
                  renderData.charCount >
                    MAX_LYRIC_COUNT - ($$language() == 'cn' ? 500 : 10) ||
                  !isEffectiveLyric
                "
                :loading="
                  renderData.lyricOptimizeGuidVisibleCount != 1 &&
                  (renderData.curGenerateType === 'all' ||
                    renderData.curGenerateType == 'lyric_optimize') &&
                  renderData.isLoading
                "
                @click="
                  () => {
                    onClickOutside();
                    if (ModuleOpenStateControl.create.lyricsOptimize) {
                      onLyricsOptimizeClick();
                    } else {
                      onWriteAllLyricClick();
                    }
                  }
                "
              >
                <div class="lyric-footer-btn-content">
                  <i class="block"></i>
                  <span class="block olh">
                    {{
                      ModuleOpenStateControl.create.lyricsOptimize
                        ? $$t("editor.lyric_optimize")
                        : renderData.title || isEffectiveLyric
                        ? $$t("create.ai_generate_lyrics")
                        : $$t("create.ai_generate_random_lyrics")
                    }}
                  </span>
                </div>
              </Button>
              <template v-slot:content>
                <div class="lyric-footer-btn-tip-content">
                  <template
                    v-for="(item, index) in (ModuleOpenStateControl.create
                      .lyricsOptimize
                      ? $$tm('editor.lyric_optimize_tip')
                      : renderData.title || isEffectiveLyric
                      ? $$t('create.ai_generate_lyrics')
                      : $$t('create.ai_generate_random_lyrics')
                    ).split('\n')"
                    :key="index"
                  >
                    <p>
                      {{ item }}
                    </p>
                  </template>
                </div>
              </template>
            </Bubble>
            <div class="driver-high-optimize">
              <div>
                {{ $$t("editor.lyric_optimize_guid") }}
              </div>
              <i class="driver-high-optimize-icon"></i>
            </div>
          </div>
          <div class="lyric-footer-btn btn2">
            <Bubble
              effect="dark"
              placement="top"
              :disabled="renderData.isLoading"
            >
              <Button
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100%',
                  '--height': '100%',
                  '--borderRadius': '0px 8px 8px 0px',
                  '--background': 'rgba(255, 255, 255, 0.1)',
                  '--fontColor': '#fff',
                  '--fontSize': '11px',
                  '--fontWeight': '500',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                  '--fontColorHover': '#fff',
                }"
                :disabled="
                  renderData.isLoading ||
                  renderData.charCount > MAX_LYRIC_COUNT - 10 ||
                  !isEffectiveLyric
                "
                :loading="
                  renderData.curGenerateType === 'row' && renderData.isLoading
                "
                @click="
                  () => {
                    onClickOutside();
                    onContinueWritingClick('row');
                  }
                "
              >
                <div class="lyric-footer-btn-content">
                  <i class="block"></i>
                  <span class="block olh">{{
                    $$t("create.ai_generate_row_btn")
                  }}</span>
                </div>
              </Button>
              <template v-slot:content>
                <div class="lyric-footer-btn-tip-content">
                  <template
                    v-for="(item, index) in $$tm(
                      'editor.ai_generate_row_tip'
                    ).split('\n')"
                    :key="index"
                  >
                    <p>
                      {{ item }}
                    </p>
                  </template>
                </div>
              </template>
            </Bubble>
          </div>
        </div>
      </div>
    </div>
    <div class="lyric-box-mask" v-if="renderData.isLoading">
      <i
        class="loading block rotate-loading"
        v-if="
          renderData.curGenerateType == 'lyric_optimize' &&
          globalConfig.appname == chinaAppName
        "
      ></i>
    </div>
    <div
      class="lyric-nologin-guid flex-center"
      v-if="
        !(
          userDataStore.isLogin ||
          curDriverKey != 'click_to_ai_generate_more_row--false'
        )
      "
    >
      <div class="lyric-nologin-guid-content">
        <div class="lyric-nologin-guid-content-desc tc">
          <p
            v-for="(item, index) in $$t('create.create_song_with_lyrics').split(
              '\n'
            )"
            :key="index"
          >
            {{ item }}
          </p>
        </div>
        <div class="lyric-nologin-guid-content-btn driver-high-breathe">
          <Button
            @click="onWriteAllLyricClick"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '48px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'narmal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.ai_write_lyrics") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import tools from "@/utils/tools.js";

import sseGenerateApi from "@/api/api/apiSse.js";

import LyricEdit from "./inputLyric.vue";
import Button from "@/components/basic/button/Button.vue";
import useLyricDataStore from "@/store/create/lyricDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import feedListApi from "@/api/api/feedListApi.js";
import message from "@/components/functionCallComponent/message.jsx";
import { getSegTypes } from "@/config/const.js";
import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";
import IconButton from "@/components/basic/button/IconButton.vue";
import Bubble from "@/components/bubble/bubble.vue";

import { storeToRefs } from "pinia";
import useDiverStore from "@/store/driverStore.js";
const driverStore = useDiverStore();
const { curDriverKey } = storeToRefs(driverStore);

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const {
  createRenderType,
  createEditGuidTourVisible,
  createEditGuidTourControlVisible,
} = storeToRefs(createLayoutStore);

const MAX_LYRIC_COUNT = globalConfig.MAX_LYRIC_COUNT;
const lyricDataStore = useLyricDataStore();

const userDataStore = useUserDataStore();

const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties;
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const props = defineProps({
  similarData: {
    type: Object,
    default: null,
  },
});

const emits = defineEmits([]);
const refLyricEdit = ref(null);
const refTitleInput = ref(null);
const renderData = reactive({
  title: "",
  lyric: "",
  charCount: 0,
  isLoading: false,
  tagVisible: false,
  curGenerateType: "",
  editMode: false,
  lyricOptimizeGuidVisibleCount:
    createLayoutStore.lyricOptimizeGuidVisibleCount,
  inputing: false,
});
const stateData = {
  cursorPosition: 0,
  beforeText: "",
  afterText: "",
  specialChars:
    /[，。、；！？‘【】、=\-·~！@#￥%……&*（）——+「」“：》!?,./;'[\]\\=)(*&^%$#@!~>?:"{}|｜¥~～·\s]/g,
  mounted: true,
};

const isEffectiveTitle = computed(() => {
  return renderData.title?.replace(/\s+|\n+/g, "").length ? true : false;
});

const isEffectiveLyric = computed(() => {
  return renderData.lyric
    ?.replace(/\s+|\n+/g, "")
    ?.replace(stateData.specialChars, "").length;
});

const onCursorPositionChange = (cursorPosition, beforeText, afterText) => {
  stateData.cursorPosition = cursorPosition;
  stateData.beforeText = beforeText;
  stateData.afterText = afterText;
};
const handleCompositionStart = () => {
  renderData.inputing = true;
};

const handleCompositionEnd = (e) => {
  renderData.inputing = false;
  onInputTitle(e);
};

const onInputTitle = async (e) => {
  // if (!(await userDataStore.checkLoginStatus())) {
  //   return;
  // }
  if (!renderData.inputing) {
    renderData.title = e.target.value;

    const maxTitleLength = 50;
    if (renderData.title.length > maxTitleLength) {
      renderData.title = renderData.title.slice(0, maxTitleLength);
    }
    lyricDataStore.updateTitle(renderData.title);
    handleInputChangeDebounceCall("title");
  }
};

const onBlurTitle = async (value) => {
  lyricDataStore.updateTitle(renderData.title);
  // lyricDataStore.saveLyric(renderData.lyric);
  renderData.editMode = false;
};

const onFocusTitle = () => {
  setTimeout(() => {
    renderData.editMode = true;
  }, 0);
  globalProperties?.logClickEvent("create_inputbox", {
    tab_stare: "song",
    source: "advanced",
    mode: "2",
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    control: "title",
  });
};

const onInput = async (value) => {
  // if (!(await userDataStore.checkLoginStatus())) {
  //   return;
  // }
  renderData.lyric = value;
  lyricDataStore.updateLyric(renderData.lyric);
  if (!renderData.lyric) {
    lyricDataStore.setIsAllAiLyrics(false);
  }

  handleInputChangeDebounceCall("lyrics");
};

const onChange = (value) => {
  renderData.lyric = value;
  lyricDataStore.updateLyric(renderData.lyric);
  driverStore.setcurDriverKey("");
};

const onBlur = (value) => {
  // lyricDataStore.saveLyric(renderData.lyric);
  renderData.editMode = false;
};

const onFocus = (value) => {
  setTimeout(() => {
    renderData.editMode = true;
  }, 0);
  globalProperties?.logClickEvent("create_inputbox", {
    tab_stare: "song",
    source: "advanced",
    mode: "2",
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    control: "lyrics",
  });
};

const handleInputChangeDebounceCall = tools.debounce((control) => {
  globalProperties?.logCustomEvent(
    "create_inputbox",
    {
      mode: "2",
      tab_stare: "song",
      source: "advanced",
      mode: "2",
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
      control: control,
    },
    "input"
  );
}, 800);

const handleEditBoxClick = () => {
  refTitleInput.value?.focus();
};

const onCountChange = (count) => {
  renderData.charCount = count;
  lyricDataStore.updateLyricCount(renderData.charCount);
  nextTick(() => {
    if (renderData.charCount >= 50) {
      driverStore.setcurDriverKey("click_to_generate_song");
    } else {
      driverStore.setcurDriverKey("");
    }
  });
};

const toggleTagVisible = async () => {
  // if (!(await userDataStore.checkLoginStatus())) {
  //   return;
  // }
  renderData.tagVisible = !renderData.tagVisible;
};

const doAddTag = async (tag) => {
  globalProperties?.logClickEvent("create_structure", {
    add_tag_type: tag,
    tab_stare: tag[`label_${$$language()}`],
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });
  // if (!(await userDataStore.checkLoginStatus())) {
  //   return;
  // }
  refLyricEdit.value.insertTag(tag);
  renderData.tagVisible = false;
};

const onClickOutside = async () => {
  renderData.tagVisible = false;
};
const insertLyric = (lyric, isTemplate) => {
  if (isTemplate) {
    if (lyric.length > 0) {
      lyric = lyric.slice(0, MAX_LYRIC_COUNT);
      renderData.lyric = lyric;
      lyricDataStore.updateLyric(renderData.lyric);
      stateData.beforeText = renderData.lyric;
      stateData.cursorPosition = stateData.beforeText.length;
      stateData.afterText = "";
    }
    return;
  }
  let contN = 0;
  if (lyric.length > 0) {
    if (stateData.beforeText.endsWith("\n")) {
      if (!lyric.startsWith("\n") || /^\[.+\]/.test(lyric)) {
        contN = 1;
      } else {
        contN = 0;
      }
    } else {
      if (!stateData.beforeText) {
        contN = 0;
      } else if (lyric.startsWith("\n") || /^\[.+\]/.test(lyric)) {
        contN = 2;
      } else {
        contN = 1;
      }
    }
    let beforeText =
      (stateData.beforeText ?? "") +
      Array.from({ length: contN }, (_, i) => "\n").join("");
    const count = beforeText.length + (stateData?.afterText ?? "").length;

    if (count < MAX_LYRIC_COUNT) {
      beforeText += lyric.slice(0, MAX_LYRIC_COUNT - count);
      stateData.beforeText = beforeText;
      renderData.lyric = stateData.beforeText + stateData.afterText;
      lyricDataStore.updateLyric(renderData.lyric);
      stateData.cursorPosition = stateData.beforeText.length;
    }
  }
  lyricDataStore.isLoading = false;
};

const onWriteSingleLyricClick = async (curGenerateType) => {
  renderData.tagVisible = false;
  if (isEffectiveTitle.value) {
    globalProperties?.logClickEvent("create_writeabout", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    });
  } else {
    globalProperties?.logClickEvent("create_randomlyrics", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    });
  }

  lyricDataStore.updateAiClickCount(
    "randomLyrics",
    lyricDataStore.aiClickCountMap["randomLyrics"] + 1
  );
  if (
    lyricDataStore.aiClickCountMap["randomLyrics"] > 5 &&
    !(await userDataStore.checkLoginStatus())
  ) {
    return;
  }

  if (renderData.isLoading) {
    return;
  }
  renderData.isLoading = true;

  if (!props.similarData) {
    lyricDataStore.isLoading = true;
  }
  renderData.curGenerateType = "randomLyrics";
  const params = {
    lyrics: "",
    create_title: !renderData.title,
    type: 4,
    title: !renderData.title ? null : renderData.title,
  };
  feedListApi
    .generateLyrics(params)
    .then((res) => {
      if (props.similarData && !stateData.mounted) {
        return;
      }
      driverStore.setcurDriverKey("click_to_generate_song");
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      const { code, data, msg } = res;
      if (code == 200) {
        if (!renderData.title || data.isTemplate) {
          renderData.title = data.title;
          lyricDataStore.updateTitle(renderData.title);
        }

        if (refLyricEdit.value) {
          refLyricEdit.value.insertLyric(data.lyrics, true);
        } else {
          insertLyric(data.lyrics, true);
        }
        lyricDataStore.setIsAllAiLyrics(true);
      } else {
        message.error({
          position: "top",
          content: $$t("create.ai_generate_lyric_failed"),
        });
      }
    })
    .catch((e) => {
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      message.error({
        position: "top",
        content: $$t("create.ai_generate_lyric_failed"),
      });
    });
};
const onContinueWritingClick = async () => {
  renderData.tagVisible = false;
  globalProperties?.logClickEvent("create_advanced_mode_ailyrics", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });

  lyricDataStore.updateAiClickCount(
    "rowLyrics",
    lyricDataStore.aiClickCountMap["rowLyrics"] + 1
  );
  if (
    lyricDataStore.aiClickCountMap["rowLyrics"] > 5 &&
    !(await userDataStore.checkLoginStatus())
  ) {
    return;
  }

  if (renderData.isLoading) {
    return;
  }
  renderData.isLoading = true;
  if (!props.similarData) {
    lyricDataStore.isLoading = true;
  }
  const beforeLyrics = refLyricEdit.value?.getBeforeLyrics() ?? "";
  const params = {
    lyrics: beforeLyrics,
    create_title: !renderData.title,
    type: 1,
    title: !renderData.title ? null : renderData.title,
  };
  renderData.curGenerateType = "row";
  feedListApi
    .generateLyrics(params)
    .then((res) => {
      if (props.similarData && !stateData.mounted) {
        return;
      }
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      const { code, data, msg } = res;
      if (code == 200) {
        if (data.title) {
          renderData.title = data.title;
          lyricDataStore.updateTitle(renderData.title);
        }
        if (refLyricEdit.value) {
          refLyricEdit.value.insertLyric(data.lyrics);
        } else {
          insertLyric(data.lyrics);
        }
        lyricDataStore.setIsAllAiLyrics(true);
      } else {
        message.error({
          position: "top",
          content: $$t("create.ai_generate_lyric_failed"),
        });
      }
    })
    .catch((e) => {
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      message.error({
        position: "top",
        content: $$t("create.ai_generate_lyric_failed"),
      });
    });
};
const onWriteAllLyricClick = async () => {
  onClickOutside();
  createLayoutStore.toggleLyricOptimizeGuidVisible(false);
  renderData.tagVisible = false;
  globalProperties?.logClickEvent("create_advanced_mode_ailyricsall", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });
  lyricDataStore.updateAiClickCount(
    "allLyrics",
    lyricDataStore.aiClickCountMap["allLyrics"] + 1
  );
  if (
    lyricDataStore.aiClickCountMap["allLyrics"] > 5 &&
    !(await userDataStore.checkLoginStatus())
  ) {
    return;
  }
  if (renderData.isLoading) {
    return;
  }
  renderData.isLoading = true;
  const beforeLyrics = refLyricEdit.value?.getBeforeLyrics() ?? "";
  const params = {
    lyrics: beforeLyrics,
    create_title: !renderData.title,
    title: !renderData.title ? null : renderData.title,
    type: 4,
  };
  renderData.curGenerateType = "all";
  feedListApi
    .generateLyrics(params)
    .then((res) => {
      if (props.similarData && !stateData.mounted) {
        return;
      }
      driverStore.setcurDriverKey("click_to_generate_song");
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      const { code, data, msg } = res;
      if (code == 200) {
        if (!renderData.title || data.isTemplate) {
          renderData.title = data.title;
          lyricDataStore.updateTitle(renderData.title);
        }
        if (refLyricEdit.value) {
          refLyricEdit.value.insertLyric(data.lyrics, data.isTemplate);
        } else {
          insertLyric(data.lyrics, data.isTemplate);
        }
        lyricDataStore.setIsAllAiLyrics(true);
      } else {
        message.error({
          position: "top",
          content: $$t("create.ai_generate_lyric_failed"),
        });
      }
    })
    .catch((e) => {
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      message.error({
        position: "top",
        content: $$t("create.ai_generate_lyric_failed"),
      });
    });
};

const doLyricsOptimizeCn = (similarData) => {
  globalProperties?.logClickEvent("song_advanced_lyric_optimize", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });
  return new Promise(async (resolve, reject) => {
    renderData.isLoading = true;
    if (!props.similarData) {
      lyricDataStore.isLoading = true;
    }
    let optimizeLoading = true;
    renderData.oldLyric = renderData.lyric;
    let lyricsOptimized = null;
    let intervalId = null;
    renderData.lyricsOptimizeSse = await sseGenerateApi.doSseLyricsOptimize({
      params: {
        lyrics: renderData.lyric,
      },
      onOpen: (e) => {
        // renderData.lyric = ""
        // lyricsOptimized = ""
        // intervalId = setInterval(() => {
        //   if (lyricsOptimized.length > renderData.lyric.length) {
        //     renderData.lyric += lyricsOptimized.slice(
        //       renderData.lyric.length,
        //       renderData.lyric.length + 1
        //     )
        //     nextTick(() => {
        //       refLyricEdit.value?.scrollToBottom()
        //     })
        //   } else {
        //     if (!optimizeLoading) {
        //       clearInterval(intervalId)
        //       resolve(renderData.lyric)
        //       renderData.isLoading = false
        //     }
        //   }
        // }, 10)
      },
      onMessage: (res) => {
        try {
          if (["lyrics"].includes(res.event)) {
            const lyricsData = JSON.parse(res.data ?? "{}");
            lyricsOptimized =
              (lyricsOptimized ?? "") + lyricsData?.lyrics ?? "";
          } else if (["done"].includes(res.event)) {
            optimizeLoading = false;
            if (lyricsOptimized !== null) {
              renderData.lyric = lyricsOptimized;
              resolve(renderData.lyric);
            }
            renderData.isLoading = false;
            lyricDataStore.isLoading = false;
          } else if (["error"].includes(res.event)) {
            const e = JSON.parse(res.data ?? "{}");
            switch (e.code) {
              case 6103: // 标题不合规
                message.error({
                  position: "top",
                  content: $$t("create.generate_title_audit_failed"),
                });
                break;
              case 6316: // 歌词不合规
                message.error({
                  position: "top",
                  content: $$t("create.generate_lyric_audit_failed"),
                });
                break;
              case 6357:
                message.error({
                  position: "top",
                  content: $$t("create.generate_lyric_audit_failed"),
                });
                break;
              case 6104:
                message.error({
                  position: "top",
                  content: $$t("create.generate_lyric_audit_failed"),
                });
                break;
              case 6356:
                message.error({
                  position: "top",
                  content: $$t("create.generate_lyric_audit_failed"),
                });
                break;
              default:
                break;
            }
            renderData.isLoading = false;
            lyricDataStore.isLoading = false;
            optimizeLoading = false;
            renderData.lyric = renderData.oldLyric;
            lyricsOptimized = null;
            // clearInterval(intervalId)
            if ([6103, 6316, 6104, 6356, 6357].includes(e.code)) {
              reject();
            } else {
              reject(e);
            }
          } else {
          }
        } catch (e) {
          console.error("doGenerateConnectedSSE__onCatchError", e);
        }
      },
      onError: (e) => {
        renderData.isLoading = false;
        lyricDataStore.isLoading = false;
        optimizeLoading = false;
        renderData.lyric = renderData.oldLyric;
        clearInterval(intervalId);
        reject(e);
      },
      onClose: (e) => {
        renderData.lyricsOptimizeSse?.abort();
        optimizeLoading = false;
      },
    });
  });
};

const doLyricsOptimize = (similarData) => {
  globalProperties?.logClickEvent("song_advanced_lyric_optimize", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  });
  return new Promise(async (resolve, reject) => {
    renderData.isLoading = true;
    if (!props.similarData) {
      lyricDataStore.isLoading = true;
    }
    let optimizeLoading = true;
    renderData.oldLyric = renderData.lyric;
    let lyricsOptimized = "";
    let intervalId = null;
    renderData.lyricsOptimizeSse = await sseGenerateApi.doSseLyricsOptimize({
      params: {
        lyrics: renderData.lyric,
      },
      onOpen: (e) => {
        renderData.lyric = "";
        lyricsOptimized = "";
        intervalId = setInterval(() => {
          if (lyricsOptimized.length > renderData.lyric.length) {
            renderData.lyric += lyricsOptimized.slice(
              renderData.lyric.length,
              renderData.lyric.length + 1
            );
            nextTick(() => {
              refLyricEdit.value?.scrollToBottom();
            });
          } else {
            if (!optimizeLoading) {
              clearInterval(intervalId);
              resolve(renderData.lyric);
              renderData.isLoading = false;
              lyricDataStore.isLoading = false;
            }
          }
        }, 10);
      },
      onMessage: (res) => {
        try {
          if (["lyrics"].includes(res.event)) {
            const lyricsData = JSON.parse(res.data ?? "{}");
            lyricsOptimized += lyricsData?.lyrics ?? "";
          } else if (["done"].includes(res.event)) {
            optimizeLoading = false;
          } else if (["error"].includes(res.event)) {
            renderData.isLoading = false;
            lyricDataStore.isLoading = false;
            optimizeLoading = false;
            renderData.lyric = renderData.oldLyric;
            clearInterval(intervalId);
            reject("error");
          }
        } catch (e) {
          console.error("doGenerateConnectedSSE__onCatchError", e);
        }
      },
      onError: (e) => {
        renderData.isLoading = false;
        lyricDataStore.isLoading = false;
        optimizeLoading = false;
        renderData.lyric = renderData.oldLyric;
        clearInterval(intervalId);
        reject(e);
      },
      onClose: (e) => {
        renderData.lyricsOptimizeSse?.abort();
        optimizeLoading = false;
      },
    });
  });
};

const onLyricsOptimizeClick = async () => {
  const doLyricsOptimizeCall =
    globalConfig.appname == chinaAppName
      ? doLyricsOptimizeCn
      : doLyricsOptimize;
  renderData.curGenerateType = "lyric_optimize";
  doLyricsOptimizeCall(props.similarData)
    .then(() => {})
    .catch((error) => {
      renderData.isLoading = false;
      lyricDataStore.isLoading = false;
      if (error) {
        message.error({
          position: "top",
          content: $$t("editor.lyrics_optimize_failed"),
        });
      }
    });
};

defineExpose({
  getData() {
    return {
      title: renderData.title,
      lyric: renderData.lyric,
    };
  },
  optimizedLyricsCallback: () => {
    return new Promise((resolve, reject) => {
      renderData.curGenerateType = "lyric_optimize";
      const doLyricsOptimizeCall =
        globalConfig.appname == chinaAppName
          ? doLyricsOptimizeCn
          : doLyricsOptimize;
      doLyricsOptimizeCall(props.similarData)
        .then((lyric) => {
          resolve(lyric);
        })
        .catch((e) => {
          renderData.isLoading = false;
          lyricDataStore.isLoading = false;
          if (e) {
            message.error({
              position: "top",
              content: $$t("editor.create_lyrics_optimize_failed"),
            });
          }
          reject(e);
        });
    });
  },
});

watch(
  () => renderData.isLoading,
  (newVal) => {
    if (!props.similarData) {
      lyricDataStore.isLoading = renderData.isLoading;
    }
  }
);

watch(
  () => renderData.curGenerateType,
  (newVal) => {
    lyricDataStore.curGenerateType = renderData.curGenerateType;
  }
);

watch(
  () => lyricDataStore.isLoading,
  (newVal) => {
    if (!props.similarData) {
      renderData.isLoading = lyricDataStore.isLoading;
    }
  }
);

watch(
  () => lyricDataStore.title,
  (newVal) => {
    renderData.title = lyricDataStore.title;
  }
);

watch(
  () => lyricDataStore.lyric,
  (newVal) => {
    renderData.lyric = lyricDataStore.lyric;
  }
);
const initCursorPosition = () => {
  if (refLyricEdit.value) {
    refLyricEdit.value.initCursorPosition();
  } else {
    stateData.beforeText = renderData.lyric;
    stateData.cursorPosition = stateData.beforeText.length;
    stateData.afterText = "";
  }
};
watch(
  () => lyricDataStore.initTimescamp,
  (newVal) => {
    initCursorPosition();
  }
);

const titlePoint = (e) => {
  if (
    (createLayoutStore.createRenderType == "mobile" &&
      ["max", "playermax"].includes(
        createLayoutStore.create_createEditOpenState
      )) ||
    createLayoutStore.createRenderType != "mobile"
  ) {
    if (createLayoutStore.createEditMode == "hard") {
      if (e) {
        if (!isEffectiveTitle.value) {
          globalProperties?.logViewEvent("create_writeabout", {
            type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
          });
        }
      } else {
        if (isEffectiveTitle.value) {
          globalProperties?.logViewEvent("create_randomlyrics", {
            type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
          });
        } else if (!isEffectiveTitle.value) {
          globalProperties?.logViewEvent("create_randomlyrics", {
            type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
          });
        }
      }
    }
  }
};
watch(
  () => {
    return isEffectiveTitle.value;
  },
  () => {
    titlePoint(isEffectiveTitle.value);
  }
);
watch(
  () => {
    return createRenderType.editMode;
  },
  () => {
    titlePoint(isEffectiveTitle.value);
  }
);

watch(
  () => {
    return createLayoutStore.lyricOptimizeGuidVisibleCount;
  },
  () => {
    renderData.lyricOptimizeGuidVisibleCount =
      createLayoutStore.lyricOptimizeGuidVisibleCount;
    if (
      createLayoutStore.lyricOptimizeGuidVisibleCount == 1 &&
      (createLayoutStore.create_createEditOpenState == "max" ||
        createLayoutStore.createRenderType != "mobile")
    ) {
      globalProperties?.logViewEvent("lyric_optimize_prompt", {
        type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
      });
      setTimeout(() => {
        createLayoutStore.toggleLyricOptimizeGuidVisible(false);
      }, 5 * 1000);
    }
  }
);

watch(
  () => {
    return createLayoutStore.create_createEditOpenState;
  },
  () => {
    if (
      createLayoutStore.lyricOptimizeGuidVisibleCount == 1 &&
      (createLayoutStore.create_createEditOpenState == "max" ||
        createLayoutStore.createRenderType != "mobile")
    ) {
      setTimeout(() => {
        createLayoutStore.toggleLyricOptimizeGuidVisible(false);
      }, 5 * 1000);
    }
  }
);

onMounted(() => {
  document?.addEventListener("click", onClickOutside);
  stateData.mounted = true;
  renderData.title = lyricDataStore.title;
  renderData.lyric = lyricDataStore.lyric;
  renderData.curGenerateType = lyricDataStore.curGenerateType;
  if (!props.similarData) {
    renderData.isLoading = lyricDataStore.isLoading;
  }
  nextTick(() => {
    initCursorPosition();
    titlePoint(isEffectiveTitle.value);
  });
});

onUnmounted(() => {
  document?.removeEventListener("click", onClickOutside);
  stateData.mounted = false;
  if (
    createLayoutStore.lyricOptimizeGuidVisibleCount == 1 &&
    (createLayoutStore.create_createEditOpenState == "max" ||
      createLayoutStore.createRenderType != "mobile")
  ) {
    createLayoutStore.toggleLyricOptimizeGuidVisible(false);
  }
});
</script>
<style lang="scss" scope>
@keyframes fadeInOut {
  0% {
    background: rgba(255, 255, 255, 0.1);
  }
  50% {
    background: rgba(255, 255, 255, 0.2);
  }
  100% {
    background: rgba(255, 255, 255, 0.1);
  }
}
.lyric {
  padding: 17px 17px 17px 17px;
  border-radius: 12px;
  background: rgba(148, 173, 255, 0.2);
  border: none;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0);
  &:hover {
    background: rgba(148, 173, 255, 0.2);
  }
  &.lyric-edit-mode {
    border: 1px solid #94adff;
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
    &:focus-within {
      background: rgba(148, 173, 255, 0.2);
    }
  }
  &.lyric-edit-mode-active {
    background: rgba(148, 173, 255, 0.2);
  }
  &.lyric-edit-mode-disabled {
    background: rgba(255, 255, 255, 0.1);
  }
  &.lyric-edit-mode-tour-show {
    &.lyric-mobile {
      .lyric-title-btn {
        opacity: 0;
      }
      .lyric-footer {
        .lyric-footer-btn {
          opacity: 0;
        }
      }
    }
  }

  .lyric-title {
    height: 90px;
    margin-bottom: 8px;
    padding: 0 0 12px 0;
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
    flex-direction: column;
    textarea {
      height: 100%;
      width: 100%;
      border: none;
      background-color: transparent;
      color: #fff;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: bold;
      font-weight: 500;
      line-height: 20px;
      padding: 0;
      resize: none;

      /* max-width: calc(100% - 27px); */
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .lyric-title-btn {
      justify-content: end;
      margin-top: 8px;
    }
    .lyric-title-btn-box {
      max-width: 100%;
      .ico-random {
        height: 20px;
        width: 20px;
        margin-right: 6px;
        background: transparent;
        background-image: url(@/assets/img/random-black-ico.png);
        background-size: cover;
      }
    }
    .custom-button {
      max-width: 100%;
      button {
        max-width: 100%;
        padding: 0 12px;
        & > span {
          display: flex;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .el-button.is-loading {
        display: flex;
        span {
          display: none;
        }
      }
    }
  }
  .lyric-nologin-guid {
    border-radius: 12px;
    background: linear-gradient(
      111deg,
      rgba(79, 222, 255, 0.1) 0%,
      rgba(230, 117, 255, 0.1) 100%
    );
    backdrop-filter: blur(10px);
  }
  .lyric-footer-count {
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    line-height: 16px;
    padding: 16px 0 0 0;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.5);
    vertical-align: bottom;
    text-align: right;
    &.count-error {
      color: #ff4d4f;
    }
  }
  .lyric-footer {
    padding: 8px 0 0 0;
    justify-content: center;
    align-items: center;
    .count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      line-height: 16px;
      padding: 16px 0 0 0;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.5);
      vertical-align: bottom;
      width: calc(100% - 40px * 3 - 8px * 3);
    }
    .count-error {
      color: #ff4d4f;
    }
    .lyric-footer-btn {
      margin-left: 1px;
      height: 52px;
      position: relative;
      width: 0;
      flex: 1;
      .custom-button .el-button {
        padding: 0 4px;
        border-radius: 0;

        span {
          width: 100%;
        }
      }
      &:first-child {
        margin-left: 0;
        .custom-button .el-button {
          border-radius: 8px 0 0 8px;
        }
      }
      &:last-child {
        margin-right: 0;
        .custom-button .el-button {
          border-radius: 0 8px 8px 0;
        }
      }
      .lyric-footer-btn-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        i {
          height: 16px;
          width: 16px;
          min-width: 16px;
        }
        span {
          margin-top: 6px;
        }
      }

      .driver-high-optimize {
        position: absolute;
        bottom: 72px;
        left: 50%;
        transform: translateX(-50%);
        width: 259px;
        border-radius: 12px;
        padding: 14px 16px 16px 16px;
        background: #94adff;
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #ffffff;
        display: none;
        .driver-high-optimize-icon {
          position: absolute;
          left: 50%;
          bottom: -25px;
          transform: translateX(-50%) rotate(180deg);
          width: 30px;
          height: 36px;
          background: url(@/assets/img/click-ico.png);
          background-size: cover;
        }
      }

      &.driver-high-optimize-active {
        .driver-high-optimize {
          display: block;
        }
        .custom-button .el-button {
          animation: fadeInOut 1s infinite;
        }
      }
      .el-button.is-loading {
        span {
          display: none;
        }
        i.is-loading {
          display: block;
          height: 16px;
          width: 16px;
          background: url(@/assets/img/loading-mini-3x.png) !important;
          background-size: 100% 100% !important;
          animation: animation-rotate-infinite 0.75s infinite normal linear;
          svg {
            display: none;
          }
        }
      }
    }
    .btn1 {
      position: relative;
      i {
        background: url(@/assets/img/lyric-tag-ico.svg);
        background-size: cover;
      }
    }
    .btn2 {
      i {
        background: url(@/assets/img/lyric-row-ico.svg);
        background-size: cover;
      }
    }
    .btn3 {
      i {
        background: url(@/assets/img/lyric-whole-ico.svg);
        background-size: cover;
      }
    }

    .lyric-tag-items {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0);
      backdrop-filter: blur(20px);
      width: 118px;
      border-radius: 8px;
      position: absolute;
      bottom: 55px;
      left: 50%;
      transform: translateX(-50%);
      .lyric-tag-item {
        line-height: 42px;
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0em;
        color: #fff;
        &:first-child {
          border-radius: 8px 8px 0 0;
        }
        &:last-child {
          border-bottom: none;
          border-radius: 0 0 8px 8px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
  .lyric-box {
    height: 100%;
    flex-direction: column;
    &.lyric-box-disabled {
      visibility: hidden;
    }
  }
  .lyric-box-mask {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
    .rotate-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
      background: url(@/assets/img/loading-mini-3x.png) no-repeat center center;
      background-size: cover;
    }
  }
  .lyric-nologin-guid {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: 12px;
    .lyric-nologin-guid-content {
      padding: 0 40px;
    }
    .lyric-nologin-guid-content-desc {
      font-family: HarmonyOS Sans SC;
      font-size: 24px;
      font-weight: normal;
      line-height: 40px;
      color: #ffffff;
    }
    .lyric-nologin-guid-content-btn {
      margin: 24px auto 0 auto;
    }
  }
  &.lyric-mobile {
    border: 1px solid transparent;
    background-color: rgba(148, 173, 255, 0.2);
    padding: 14px 16px 14px 16px;
    &.lyric-edit-mode {
      border: 1px solid #94adff;
      &:hover {
        background: rgba(148, 173, 255, 0.2);
      }
      &:focus-within {
        background: rgba(148, 173, 255, 0.2);
      }
    }
    &.lyric-edit-mode-active {
      background: rgba(148, 173, 255, 0.2);
    }
    .lyric-tag-items {
      bottom: 30px;
      .lyric-tag-item {
        line-height: 32px;
      }
    }
    .lyric-footer-count-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .lyric-footer {
        width: max-content;
        width: 100%;
        align-items: center;
        justify-content: flex-start;
        .driver-high-optimize {
          left: 50%;
          transform: translateX(-50%);
          bottom: 40px;
          .driver-high-optimize-icon {
            width: 25px;
            height: 30px;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%) rotate(180deg);
          }
        }
      }
      .custom-button {
        max-width: 100%;
        .el-button {
          max-width: 100%;
          padding: 0 6px;
        }
      }
      .lyric-footer-btn {
        height: 26px;
        .lyric-footer-btn-content {
          flex-direction: row;
          align-items: center;
          justify-content: center;
          span {
            margin: 0 0 0 4px;
            width: max-content;
            max-width: calc(100% - 20px);
            margin: 2px 0 0 4px;
          }
        }
      }
    }
  }
  &.lyric-edit-mode-loading {
    .lyric-box {
      .lyric-edit {
        filter: blur(3px);
      }
    }
  }
}
.lyric-footer-btn-tip-content {
  max-width: 300px;
}
</style>
